export interface VoiceCaptureResult {
  blob: Blob;
  mimeType: string;
  durationMs: number;
}

export interface VoiceCaptureSession {
  mimeType: string;
  stop: () => Promise<VoiceCaptureResult>;
  cancel: () => Promise<void>;
}

export interface VoiceCapturePort {
  start: () => Promise<VoiceCaptureSession>;
}

export class VoiceCaptureError extends Error {
  constructor(
    public readonly code: 'unsupported' | 'permission-denied' | 'recording-failed',
    message: string,
    public readonly cause?: unknown
  ) {
    super(message);
    this.name = 'VoiceCaptureError';
  }
}
